 

import React from "react"



class Calendly extends React.Component {
    componentWillMount() {




        try {
            const script = document.createElement('script');
            script.setAttribute('src',  'https://assets.calendly.com/assets/external/widget.js');
            script.onload = (function(){
              this.setState({loaded: true})
         }).bind(this);
            document.head.appendChild(script);
        } catch (error) {
          console.error(error);

        }

    }

    render(){
      return (
        <div>

          <button className="flat-button" onClick={()=>{ window.Calendly.initPopupWidget({url: 'https://calendly.com/circadence-sales/discovery-call'})} }>Request a Demo</button>

        </div>
      );
    }
  }


export default Calendly
//window.Calendly.initPopupWidget({url: 'https://calendly.com/circadence-sales/discovery-call'});return false;
